import { Component } from 'base/js/aem';
import { Modal } from 'bootstrap';
import { consentCheck, getCookie, PERFORMANCE, TARGETING, FUNCTIONAL } from 'base/js/templates/general/consentCheck.js';
import { onIntersect } from 'base/js/templates/general/onIntersect.js';

class CustomModal extends Component {
    init() {
        this.initModal();
    }
    initModal() {
        this.timeouts = {
            epic: 2000,
            long: 1000,
            medium: 500,
            short: 100
        };
        this.percent = {
            full: 100,
            half: 50
        };
        const modalElem = this.element.querySelector('.modal');
        const modalId = modalElem.getAttribute('id');
        const trigger = modalElem.querySelector('.modal-dialog').getAttribute('modal-trigger');
        const modalContainer = new Modal(modalElem);
        const enableCookie = modalElem.querySelector('.modal-dialog').getAttribute('enable-cookie');
        const cookieExpiration = parseInt(modalElem.querySelector('.modal-dialog').getAttribute('cookie-expiration'), 10);
        const hashValue = window.location.hash.slice(1);
        let targetElement;

        if (hashValue) {
            targetElement = document.querySelector(`#${hashValue}`);
        }

        if (modalId){
            const params = new URLSearchParams(window.location.search);
            const modalIdParam = params.has('modal') ? params.get('modal') : '';

            if (modalIdParam !== '' && modalIdParam === modalId) {
                window.setTimeout(() => this.showModal(modalId, modalContainer, enableCookie, cookieExpiration),
                    this.timeouts.short);
            }

            if (trigger === 'exit') {
                document.addEventListener('mouseleave', event => {
                    if (event.clientY <= 0) {
                        this.showModal(modalId, modalContainer, enableCookie, cookieExpiration);
                    }
                }, { once: true });
            } else if (trigger === 'delay') {
                if (window.location.hash) {
                    const delayObserver = onIntersect(targetElement,
                        () => window.setTimeout(() =>
                            modalContainer.show(), this.timeouts.epic),
                        () => {
                            window.setTimeout(() =>
                            // Opens Modal if scrolling to anchor element stops prematurely
                                this.showModal(modalId, modalContainer, enableCookie, cookieExpiration), this.timeouts.epic);
                            delayObserver.unobserve(targetElement);
                        },
                        true,
                        { threshold: 0.5 }
                    );
                } else {
                    window.setTimeout(() =>
                        this.showModal(modalId, modalContainer, enableCookie, cookieExpiration),
                    this.timeouts.epic);
                }
            } else if (trigger === 'scroll') {
                let scrollPercentage = modalElem.querySelector('.modal-dialog').getAttribute('scroll-percentage');
                const percentage = () => {
                    return scrollPercentage ? parseInt(scrollPercentage, 10) : this.percent.half;
                };
                let shown = false;
                const showOnScroll = () => {
                    if (window.scrollY >= document.body.scrollHeight * percentage() / this.percent.full) {
                        shown = true;
                        this.showModal(modalId, modalContainer, enableCookie, cookieExpiration);
                        document.removeEventListener('scroll', showOnScroll);
                    }
                };

                if (window.location.hash) {
                    const scrollObserver = onIntersect(targetElement, () => window.setTimeout(() => {
                        showOnScroll();
                        if (!shown) {
                            document.addEventListener('scroll', showOnScroll);
                        }
                    }, this.timeouts.long),
                    () => {
                        // Add event listener if scrolling to anchor element stops prematurely
                        window.setTimeout(() => document.addEventListener('scroll', showOnScroll),
                            this.timeouts.long);
                        scrollObserver.unobserve(targetElement);
                    },
                    true,
                    { threshold: 0.5 });
                } else {
                    window.setTimeout(showOnScroll, this.timeouts.medium);
                    document.addEventListener('scroll', showOnScroll);
                }
            }
        }

        modalElem.addEventListener('hide.bs.modal', () => {
            if (window.location.hash.includes(modalId)) {
                window.history.pushState('', document.title, window.location.pathname + window.location.search);
            }
        });

        window.addEventListener('hashchange', () => {
            if (window.location.hash.substring(1) === modalId) {
                window.setTimeout(() => modalContainer.show(), this.timeouts.short);
            }
        });
    }

    setCookie(name, value, expire) {
        let expires = '';
        // Number of milliseconds in a day.
        const days = 86400000;
        if (expire) {
            const date = new Date();
            date.setTime(date.getTime() + expire * days);
            expires = `expires=${ date.toUTCString() }`;
        }
        document.cookie = `${ name }=${ value };${ expires };path=/`;
    }

    showModal(id, modal, cookie, expire) {
        let cookieName = `modal-${ id}`;
        let modalOpened = false;
        const consent = { value: false };
        const getConsent = () => {
            consent.value = consentCheck([ PERFORMANCE, TARGETING, FUNCTIONAL ]);
        };

        if (!getCookie(cookieName)) {
            if (cookie === 'true') {
                getConsent();
                window.addEventListener('cookiesUpdated', () => {
                    getConsent();
                    if (consent.value === true && !getCookie(cookieName) && modalOpened) {
                        this.setCookie(cookieName, id, expire);
                    }
                });
                if (consent.value === true) {
                    this.setCookie(cookieName, id, expire);
                }
            }
            modal.show();
            modalOpened = true;
        }
    }
}

export { CustomModal };
